<section id="brands" class="py-8 bg-dark">
  <div class="container mx-auto px-4">
    
    <div class="grid grid-cols-1 md:grid-cols-3 gap-6 max-w-7xl mx-auto">
      <div *ngFor="let partner of partners$ | async; let i = index; trackBy: trackByPartnerId">
        <a 
          [href]="getPartnerUrl(partner)"
          (click)="onPartnerClick(partner, $event)"
          class="block bg-dark-light rounded-lg shadow-lg hover:shadow-glow transition-all duration-300 p-6 cursor-pointer border border-primary/20 hover:border-primary h-full flex flex-col"
        >
          <div class="relative mb-4 flex justify-center">
            <!-- Logo -->
            <div class="w-full h-32 bg-dark p-4 rounded-lg flex items-center justify-center">
              <img 
                *ngIf="!hasImageError(partner.id)"
                [src]="partner.logo" 
                [alt]="partner.name"
                class="max-w-full max-h-full object-contain"
                (error)="onImageError(partner.id, $event)"
                loading="lazy"
              />
              <div *ngIf="hasImageError(partner.id)" class="text-gray-500 text-sm text-center">
                {{ partner.name }}
              </div>
            </div>
          </div>

          <!-- Content -->
          <div class="flex-1 flex flex-col text-center">
            <h3 class="text-xl font-bold mb-2 text-light">{{ partner.name }}</h3>
            <p class="text-gray-300 mb-4 text-sm flex-1">{{ partner.bonusText }}</p>
            
            <!-- Rating -->
            <div class="flex items-center justify-center gap-2 mb-4">
              <div class="flex items-center bg-dark p-2 rounded-lg">
                <span class="text-xl font-bold text-primary">{{ getRating(partner.order) }}</span>
                <span class="text-gray-400 ml-1 text-sm">/ 10</span>
              </div>
              <div class="flex items-center">
                <span *ngFor="let star of getStarArray(getStars(partner.order))" class="text-primary text-lg">★</span>
                <span *ngIf="hasHalfStar(getStars(partner.order))" class="text-primary text-lg">½</span>
                <span *ngFor="let star of getEmptyStarArray(getEmptyStarCount(getStars(partner.order)))" class="text-gray-600 text-lg">★</span>
              </div>
            </div>

            <!-- CTA Button -->
            <button class="bg-primary text-light px-6 py-3 rounded-lg font-semibold hover:bg-orange-700 transition-all duration-300 w-full transform hover:scale-105">
              Bezoek {{ partner.name }}
            </button>
          </div>
        </a>
      </div>
    </div>
  </div>
</section>

